import _ from 'underscore';

function addClass(classes, newClass) {
  let classNames;

  if (_.isArray(classes)) {
    classNames = classes;
  } else if (_.isString(classes)) {
    classNames = classes.split(' ');
  } else {
    classNames = [];
  }

  return _.chain(classNames)
    .concat([newClass])
    .uniq()
    .concat()
    .value();
}

function decorateAggregatedRows(rows) {
  return _.map(rows, row => _.defaults({
    classes: addClass(row.classes, 'aggregated-row'),
    type: 'aggregated',
  }, row));
}

function aggregatedRowsHandler(state, {
  top,
  bottom,
}) {
  const { items } = state;
  const view = this;

  /**
   * @callback AggregatedRowsCallback
   * @param {Object[]} items - All data items in the grid
   * @param {Object} context - More context parameters
   * @param {GridView} context.view - The associated grid view
   * @returns {RowConfig[]}
   */
  const topRows = decorateAggregatedRows(top.getRows(items, { view }));
  const bottomRows = decorateAggregatedRows(bottom.getRows(items, { view }));

  let { headRows, bodyRows, footRows } = state;

  headRows = top.appendToHeader ? _.flatten([headRows, topRows]) : headRows;
  bodyRows = top.appendToHeader ? bodyRows : _.flatten([topRows, bodyRows]);

  bodyRows = bottom.prependToFooter ? bodyRows : _.flatten([bodyRows, bottomRows]);
  footRows = bottom.prependToFooter ? _.flatten([bottomRows, footRows]) : footRows;

  return _.defaults({ headRows, bodyRows, footRows }, state);
}

function normalizeAggregatedRowsConfig({
  top = {},
  bottom = {},
} = {}) {
  return {
    top: _.defaults({}, top, {
      getRows: () => [],
      appendToHeader: false,
    }),
    bottom: _.defaults({}, bottom, {
      getRows: () => [],
      prependToFooter: false,
    }),
  };
}

export const aggregatedRowsProjection = {
  name: 'aggregatedRows',
  handler: aggregatedRowsHandler,
  defaults: {},
  normalize: normalizeAggregatedRowsConfig,
};

